<template>
  <div>
    <v-row justify="center">
      <v-col
        cols="12"
        class="text-center"
      >
        <v-subheader class="display-2">Datos en Tiempo Real de Variadores</v-subheader>
      </v-col>
    </v-row>
    <v-data-table
      :headers="table_header_real_time"
      :items="data"
      :items-per-page="5"
      class="elevation-1"
    ></v-data-table>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "VariatorView",
  // props: {
  //   client: Object,
  // },
  data() {
    return {
      variador1: [],
      variador2: [],
      variador3: [],

      data: [],

      //headers
      table_header_real_time: [
        { text: "Variador", value: "name" },
        { text: "Voltage", value: "voltage" },
        { text: "Frecuencia", value: "frecuencia" },
        { text: "Velocidad de motor", value: "motor_speed" },
        { text: "Energía acumulada", value: "energia_acumulada" },
        { text: "Corriente de salida", value: "corriente_salida" },
      ],
    };
  },
  computed: {
    ...mapState("nodered", ["client"]),
  },
  watch: {},
  methods: {
    ...mapActions("nodered", ["doSubscribe", "destroyConnection", "doUnsubscribe"]),

    createData() {
      //variador 1
      const var1 = { name: "Variador 1" };
      this.variador1.forEach((variable) => {
        var1[variable.name] = variable.value;
      });

      //variador 2
      const var2 = { name: "Variador 2" };
      this.variador2.forEach((variable) => {
        var2[variable.name] = variable.value;
      });

      //variador 3
      const var3 = { name: "Variador 3" };
      this.variador3.forEach((variable) => {
        var3[variable.name] = variable.value;
      });

      this.data = [var1, var2, var3];
    },
  },
  created() {
    this.doSubscribe("variador3");
    this.doSubscribe("variador2");
    this.doSubscribe("variador1");
    this.client.on("message", (topic, message) => {
      console.log(topic, JSON.parse(message.toString()));
      if (topic == "variador1") {
        this.variador1 = JSON.parse(message.toString());
        // return message.toString();
      } else if (topic == "variador2") {
        this.variador2 = JSON.parse(message.toString());
        // console.log(topic, message.toString());
      } else if (topic == "variador3") {
        this.variador3 = JSON.parse(message.toString());
        // console.log(topic, message.toString());
      }

      this.createData();
    });

    // this.leerDatosVariadores();
  },
  // beforeDestroy() {
  //   //desconectar del broker
  //   this.destroyConnection();
  // },
};
</script>
<style scoped>
.v-subheader {
  font-weight: bold;
}
</style>
